import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-task-count-technician',
  templateUrl: './task-count-technician.component.html',
  styleUrls: ['./task-count-technician.component.css']
})
export class TaskCountTechnicianComponent implements OnInit {

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  ngOnInit(): void {
  }

  getAllTaskCountForTechnician(){
    this.generic_service.getAllTaskCountForTechnician().subscribe(
      (response:any)=>{
        console.log(response)
      },
      (error: any)=>{

      }
    )
  }

}
